import { render, staticRenderFns } from "./SetupLargeFilesHarvester.vue?vue&type=template&id=3313adf2&"
import script from "./SetupLargeFilesHarvester.vue?vue&type=script&lang=ts&"
export * from "./SetupLargeFilesHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports